// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyB2Y4eUguakV--KP9ZoYC8ODDOmzCQ9Mi8",
  authDomain: "website-aadcb.firebaseapp.com",
  projectId: "website-aadcb",
  storageBucket: "website-aadcb.appspot.com",  // Fixed storage bucket URL
  messagingSenderId: "799516257896",
  appId: "1:799516257896:web:a1cea04e939d6b40dd55dd",
  measurementId: "G-DQGT0HRT6F"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const auth = getAuth(app); // Added authentication support
const db = getFirestore(app); // Added Firestore support (optional)
const storage = getStorage(app); // Added Firebase Storage support

// Export Firebase services
export { app, analytics, auth, db, storage };
